module.exports = __webpack_public_path__ + "img/pl.03ade50f.svg";